import moment from "moment";
import { getCurrentLocale } from "@user-center/utils/i18n.ts";
import { localizeI18nRecord } from "~/utils/i18nJson.js";

export interface NoticeData {
  title?: string;
  content?: string;
  i18nJson?: string | Record<string, unknown> | null;
  [key: string]: any;
}

/**
 * 公告文案回退顺序：用户当前语言 -> 公告配置的店铺默认语言 -> 外层字段。
 * title 和 content 独立回退，避免某个字段缺少翻译时影响另一个字段。
 */
export function localizeNotice(
  notice: NoticeData,
  currentLocale?: string
): NoticeData {
  return localizeI18nRecord(notice, ["title", "content"], currentLocale);
}

export function localizeNotices(
  list: NoticeData[] = [],
  currentLocale = getCurrentLocale()
): NoticeData[] {
  return list.map((notice) => localizeNotice(notice, currentLocale));
}

export function filterActiveNotices(list: any[] = []) {
  return list.filter((notice: any) => {
    const hasStart = !!notice?.startTime;
    const hasEnd = !!notice?.endTime;
    if (notice?.status !== 1) {
      return false;
    }
    if (!hasStart) {
      return true;
    }
    if (hasStart && !hasEnd) {
      return moment().isAfter(notice.startTime);
    }
    return moment().isAfter(notice.startTime) && moment().isBefore(notice.endTime);
  });
}

export function getNoticeHideUntilKey(scope = "default") {
  return `notice-hide-until:${scope}`;
}

export function isNoticeHiddenByScope(scope = "default") {
  if (!process.client) {
    return false;
  }
  const rawValue = window.localStorage.getItem(getNoticeHideUntilKey(scope));
  const timestamp = rawValue ? Number(rawValue) : 0;
  return Number.isFinite(timestamp) && timestamp > Date.now();
}

export function hideNoticeByDays(scope = "default", days = 3) {
  if (!process.client) {
    return;
  }
  const hideUntil = Date.now() + days * 24 * 60 * 60 * 1000;
  window.localStorage.setItem(getNoticeHideUntilKey(scope), String(hideUntil));
}
